// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],
  notifyDelete: null,
  notifyFailedDelete: null,

  selectedDoctorData: null,
  
  // New states for create/update/upload operations
  saving: false,
  uploading: false,
  error: null,
  
  // States for list operations
  items: [],
  loading: false,
  deleting: false
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        allData: action.allData,        
        data: action.data,
        total: action.totalPages,
        params: action.params
      }   
    case 'GET_SELECTED_DETAIL_DOCTOR':
      return {
        ...state,
        selectedDoctorData: action.doctorData
      } 
    case 'RESET_SELECTED_DETAIL_DOCTOR':
      return {
        ...state,
        selectedDoctorData: null
      }
    
    // Create Doctor cases
    case 'CREATE_DOCTOR_START':
      return {
        ...state,
        saving: true,
        error: null
      }
    case 'CREATE_DOCTOR_SUCCESS':
      return {
        ...state,
        saving: false,
        error: null,
        data: [...state.data, action.doctor]
      }
    case 'CREATE_DOCTOR_FAILURE':
      return {
        ...state,
        saving: false,
        error: action.error
      }
    
    // Update Doctor cases
    case 'UPDATE_DOCTOR_START':
      return {
        ...state,
        saving: true,
        error: null
      }
    case 'UPDATE_DOCTOR_SUCCESS':
      return {
        ...state,
        saving: false,
        error: null,
        data: state.data.map(doctor => (
          doctor.uuid === action.doctor.uuid ? action.doctor : doctor
        ))
      }
    case 'UPDATE_DOCTOR_FAILURE':
      return {
        ...state,
        saving: false,
        error: action.error
      }
    
    // Upload Photo cases
    case 'UPLOAD_DOCTOR_PHOTO_START':
      return {
        ...state,
        uploading: true,
        error: null
      }
    case 'UPLOAD_DOCTOR_PHOTO_SUCCESS':
      return {
        ...state,
        uploading: false,
        error: null,
        data: state.data.map(doctor => (
          doctor.uuid === action.doctor.uuid ? action.doctor : doctor
        ))
      }
    case 'UPLOAD_DOCTOR_PHOTO_FAILURE':
      return {
        ...state,
        uploading: false,
        error: action.error
      }
    
    // Fetch Doctors cases
    case 'FETCH_DOCTORS_START':
      return {
        ...state,
        loading: true,
        error: null
      }
    case 'FETCH_DOCTORS_SUCCESS':
      return {
        ...state,
        loading: false,
        error: null,
        items: action.items,
        total: action.total
      }
    case 'FETCH_DOCTORS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }
    
    // Delete Doctor cases
    case 'DELETE_DOCTOR_START':
      return {
        ...state,
        deleting: true,
        error: null
      }
    case 'DELETE_DOCTOR_SUCCESS':
      return {
        ...state,
        deleting: false,
        error: null,
        items: state.items.filter(item => (item.id || item.uuid) !== action.id),
        total: Math.max(0, state.total - 1)
      }
    case 'DELETE_DOCTOR_FAILURE':
      return {
        ...state,
        deleting: false,
        error: action.error
      }
   
    default:
      return state
  }
}

export default DataTablesReducer